export const TESTNET_CHAIN_ID = 7082400
export const TESTNET_RPC_URL = 'https://testnet.coti.io/rpc'

// 1. Get projectId
export const WALLET_CONNECT_PROJECT_ID: string = 'COTI_REMIX_PLUGIN'

// 2. Set chains
export const TESTNET_CONFIG = {
  chainId: TESTNET_CHAIN_ID,
  name: 'COTI Testnet',
  currency: 'COTI',
  explorerUrl: 'https://testnet.cotiscan.io/overview',
  rpcUrl: TESTNET_RPC_URL
}

// 3. Create a metadata object
export const WALLET_CONNECT_METADATA = {
  name: 'COTI Remix Plugin',
  description: 'Plugin to add full support for the COTI V2 network to the Remix IDE',
  url: '', // origin must match your domain & subdomain
  icons: ['']
}

export const ACCOUNT_ONBOARD_ADDRESS = '0x24D6c44eaB7aA09A085dDB8cD25c28FFc9917EC9'

export const ACCOUNT_ONBOARD_ABI = ['function onboardAccount(bytes calldata publicKey, bytes calldata signedEK)', 'event AccountOnboarded(address indexed _from, bytes userKey1, bytes userKey2)']

// taken from https://etherscan.io/solcversions
export const SUPPORTED_COMPILER_VERSIONS = [
  '0.8.19+commit.7dd6d404',
  '0.8.18+commit.87f61d96',
  '0.8.17+commit.8df45f5f',
  '0.8.16+commit.07a7930e',
  '0.8.15+commit.e14f2714',
  '0.8.14+commit.80d49f37',
  '0.8.13+commit.abaa5c0e',
  '0.8.12+commit.f00d7308',
  '0.8.11+commit.d7f03943',
  '0.8.10+commit.fc410830',
  '0.8.9+commit.e5eed63a',
  '0.8.8+commit.dddeac2f',
  '0.8.7+commit.e28d00a7',
  '0.8.6+commit.11564f7e',
  '0.8.5+commit.a4f2e591',
  '0.8.4+commit.c7e474f2',
  '0.8.3+commit.8d00100c',
  '0.8.2+commit.661d1103',
  '0.8.1+commit.df193b15',
  '0.8.0+commit.c7dfd78e'
]

export const ENCRYPTED_INPUT_TYPES = ['itBool', 'itUInt8', 'itUint16', 'itUint32', 'itUint64', 'itUint128', 'itString']

export const ENCRYPTED_OUTPUT_TYPES = ['ctBool', 'ctUInt8', 'ctUint16', 'ctUint32', 'ctUint64', 'ctUint128', 'ctString']